import { environment } from "../../../environments/environment";

/** Replaced at build time by the `define` option in angular.json (`v2` configuration). */
declare const NGX_DASHBOARD_V2: boolean;

/**
 * Dashboard v2 — the Nightline layout (skin, rail + panel nav, new dashboard,
 * login stage). Default is v1, the classic dashboard. v2 is on when either:
 *  - the build asks for it: `--configuration <env>,v2` (`npm run build:v2`,
 *    `npm run start:v2`, or `ng serve --configuration v2`);
 *  - the environment file sets `dashboardVersion: 2`.
 */
export const DASHBOARD_V2: boolean =
  (typeof NGX_DASHBOARD_V2 !== "undefined" && NGX_DASHBOARD_V2) || (environment as { dashboardVersion?: number }).dashboardVersion === 2;

const NIGHTLINE_FONTS =
  "https://fonts.googleapis.com/css2?family=Chakra+Petch:wght@600;700&family=Figtree:wght@400;500;600;700&family=JetBrains+Mono:wght@500;600;700&display=swap";

/**
 * Turns v2 on before the app bootstraps: the `ds-nl` class on <body> is the
 * switch every Nightline style and component reads, and the Nightline type is
 * only fetched when it will be used.
 */
export function applyDashboardVersion(): void {
  if (!DASHBOARD_V2) {
    return;
  }
  document.body.classList.add("ds-nl");
  const fonts = document.createElement("link");
  fonts.rel = "stylesheet";
  fonts.href = NIGHTLINE_FONTS;
  document.head.appendChild(fonts);
}
